<template>
  <div>
    <div class="d-flex justify-content-end">
      <b-button
        class="mr-1"
        variant="outline-secondary"
        size="sm"
        @click="$emit('add-from-form')"
      >
        {{ $t('unit.add_from_form') }}
      </b-button>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="downloadTemplate()"
      >
        {{ $t('unit.download_template') }}
      </b-button>
    </div>
    <b-row class="justify-content-center mt-1">
      <b-col cols="6">
        <b-form-group
          class="text-capitalize"
          :label="$t('unit.template')"
          label-for="file"
        >
          <b-form-file
            id="file"
            accept=".xlsx"
            :browse-text="$t('unit.search')"
            :placeholder="$t('unit.select_template')"
            :disabled="loading"
            :value="file"
            @input="setFile($event)"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="auto"
        class="align-self-center px-0"
        style="margin-top: 7px;"
      >
        <b-button
          variant="primary"
          :disabled="disabledSubmitButton"
          @click="submit()"
        >
          {{ $t('actions.accept') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { computed,ref } from "@vue/composition-api";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import axios from "@axios";

export default {
  props: {
    propItemData: {
      type: Object
    }
  },
  setup (props, { emit }) {
    //COMPOSABLES
    const toast = useToast();

    //DATA
    const file = ref(null);

    const loading = ref(false);

    //COMOUTED
    const disabledSubmitButton = computed(() => (!file.value || loading.value));

    //METHODS
    const downloadTemplate = () => {
      const link = document.createElement('a');

      link.href = "/unit_template.xlsx";
      link.download = "unit_template.xlsx";

      link.click();
      link.remove();
    }

    const setFile = async (event) => {
      file.value = event;
    }

    const submit = async () => {
      const headers = {
        headers: { "Content-Type": "multipart/form-data" }
      }

      const formData = new FormData();

      formData.append('id_unit', props.propItemData.id);
      formData.append('file', file.value);

      loading.value = true;

      await axios.post('v1/unit/import-extra-info', formData , headers)
        .then(response => {
          const { data } = response;

          props.propItemData.additional_info = [...props.propItemData.additional_info, ...data.data];
          file.value = null;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })

          emit('fecth-data');
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.message}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: string
            },
          });
        })
        .finally(() => {
          loading.value = false;
        })
    }

    return {
      file,
      loading,

      disabledSubmitButton,

      downloadTemplate,
      setFile,
      submit
    }
  }
}
</script>
